import * as React from 'react'
import { Award } from 'react-feather'

import { useWhitelabel } from 'main/framework'
import { Networks } from 'main/framework/WhiteLabelContext'
import useAppFeatureFlags from 'main/hooks/useAppFeatureFlags'
import { NativeLink, Strong, Text } from 'main/ui'
import { AssetName } from 'main/util/asset'
import Bullet from '../../common/Bullet'

import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { i18nKeyPrefix } from '../../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-LICENSE`

interface IProps {
  licenseNumber: string
  licenseStatus?: string | null
  licenseProofUrl?: string | null
  externalLicenseUrl?: string | null
  slug: string | null
}

const Body = ({
  licenseProofUrl,
  licenseStatus,
  externalLicenseUrl,
  licenseNumber,
  slug,
}: IProps) => {
  const { appFeatureFlagEnabled } = useAppFeatureFlags()
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const whitelabel = useWhitelabel()

  const pending = licenseStatus && licenseStatus !== 'approved'

  if (pending) {
    return <Text muted>{t(`${PRE}-PENDING`)}</Text>
  } else if (
    licenseProofUrl &&
    whitelabel.evaluateToTrueExceptIfFalse(AssetName.LICENSE_NUMBER_PROOF_LINK)
  ) {
    return (
      <NativeLink href={licenseProofUrl} target="_blank">
        #{licenseNumber}
      </NativeLink>
    )
  } else if (
    externalLicenseUrl &&
    whitelabel.evaluateToFalseExceptIfTrue(AssetName.EXTERNAL_LICENSE_URL) &&
    appFeatureFlagEnabled('react_redirect_to_health_and_safety_modal')
  ) {
    return (
      <NativeLink href={`/listings/${slug}?health_and_safety_report_modal=true`}>
        #{licenseNumber}
      </NativeLink>
    )
  } else if (
    externalLicenseUrl &&
    whitelabel.evaluateToFalseExceptIfTrue(AssetName.EXTERNAL_LICENSE_URL)
  ) {
    return (
      <NativeLink href={externalLicenseUrl} target="_blank">
        #{licenseNumber}
      </NativeLink>
    )
  } else {
    return <Text muted>#{licenseNumber}</Text>
  }
}

export default function License(props: IProps) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const whitelabel = useWhitelabel()

  const isNewMexico = whitelabel.networkAbbr === Networks.NM
  const titleText = isNewMexico ? t(`${PRE}-HEALTH-SAFETY`) : t(`${PRE}-NUMBER-TITLE`)
  const linkLabel = isNewMexico ? <Text muted>{t(`${PRE}-LICENSE`)}</Text> : null

  return (
    <Bullet icon={<Award strokeWidth={1} />}>
      <Strong>{titleText}</Strong>
      <span>
        {linkLabel} <Body {...props} />
      </span>
    </Bullet>
  )
}
